import React from 'react'
import Drawer from '@mui/material/Drawer'
import { Box, Divider } from '@mui/material'
import { Link } from 'react-scroll'
import CloseIcon from '@mui/icons-material/Close'
import NAV_LINKS from './nav-link'

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  return (
    <Drawer
      anchor='right'
      variant='temporary'
      open={sidebarOpen}
      onClose={() => toggleSidebar(!sidebarOpen)}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <Box flexDirection='column' display='flex' width={300}>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            padding: '20px',
          }}
        >
          <CloseIcon onClick={() => toggleSidebar(!sidebarOpen)} />
        </Box>
        <Divider />
        {NAV_LINKS.map((link, index) => (
          <React.Fragment key={link.id}>
            <Link
              offset={link.offset}
              style={{
                color: 'black',
                textDecoration: 'none',
                margin: '0',
                fontFamily: 'Gothic',
                fontWeight: '400',
                fontSize: '1rem',
                lineHeight: '1.5',
                cursor: 'pointer',
                transition: 'color 0.3s',
                padding: '15px 20px',
              }}
              to={link.id}
              smooth={true}
              activeStyle={{
                borderBottom: '2px solid #1d4ed8',
                color: '#1d4ed8',
              }}
              spy={true}
              onClick={() => toggleSidebar(!sidebarOpen)}
            >
              {link.label}
            </Link>
            {index < NAV_LINKS.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </Box>
    </Drawer>
  )
}
